import { WorkspaceDocumentType } from 'scribe-web-shared/types/document';
import SortParam from 'v2/components/_workspace/SortParam';

import fetcher from '../../utils/api';
import { WorkspacePermission } from '../types';

export type WorkspaceFetchArgs = {
  folder?: string | null;
  typeFilter?: WorkspaceDocumentType;
  userOwnerFilter?: string | null;
  sortParam?: SortParam;
  skip?: number;
  category?: string;
  permission?: WorkspacePermission;
  organizationId?: string;
  isShared?: boolean;
};

export default {
  fetch: async ({
    folder,
    typeFilter,
    userOwnerFilter,
    sortParam,
    skip,
    category,
    permission = 'all',
    organizationId,
    isShared
  }: WorkspaceFetchArgs) => {
    const queryStringArray = ['get_first=20'];

    if (folder) {
      queryStringArray.push(`folder=${folder}`);
    }
    if (typeFilter) {
      queryStringArray.push(`type=${typeFilter}`);
    }
    if (skip) {
      queryStringArray.push(`skip=${skip}`);
    }
    if (category) {
      queryStringArray.push(`category=${category}`);
    }
    if (userOwnerFilter) {
      queryStringArray.push(`user_id=${userOwnerFilter}`);
    }
    if (sortParam) {
      queryStringArray.push(`sort_by=${sortParam}`);
    }
    if (permission) {
      queryStringArray.push(`global_permission=${permission}`);
    }
    if (isShared !== undefined) {
      queryStringArray.push(`is_shared=${isShared}`);
    }
    const queryString = queryStringArray.length > 0 ? `?${queryStringArray.join('&')}` : '';

    return fetcher(`workspace/${organizationId ? `${organizationId}/` : ''}${queryString}`, 'GET', true);
  },
  changeFolderOrder: async ({ id, newOrder, newFolderId }: { id: string; newOrder: number; newFolderId: string | null }) => {
    const body = {
      folder_sort_order: newOrder,
      folder_id: newFolderId
    };

    return fetcher(`documents/${id}/`, 'PATCH', true, body);
  },
  getSidebarInfo: async () => {
    return fetcher('workspace/sidebar_info/', 'GET', true);
  },
  getFeaturedAppTags: async ({ includeTeamMembers }: { includeTeamMembers?: boolean } = {}) => {
    const queryString = includeTeamMembers ? '?include_team_members=true' : '';

    return fetcher(`workspace/featured_app_tags/${queryString}`, 'GET', true);
  }
};
